import { useMutation, useQuery } from '@tanstack/react-query';
import { configAPI } from '../services/api';
import toast from '../utils/toast';

export const useTrainingMaterials = () => useQuery({
  queryKey: ['training-materials', 'list'],
  queryFn: async () => {
    const response = await configAPI.getTrainingMaterials();
    return response.data;
  },
  staleTime: 10 * 60 * 1000,
  retry: 1,
});

export const useTrainingMaterial = (materialKey) => useQuery({
  queryKey: ['training-materials', 'detail', materialKey],
  queryFn: async () => {
    const response = await configAPI.getTrainingMaterial(materialKey);
    return response.data;
  },
  enabled: Boolean(materialKey),
  staleTime: 10 * 60 * 1000,
  retry: 1,
});

export const useDownloadTrainingMaterialPdf = () => useMutation({
  mutationFn: async ({ materialKey, filename }) => {
    const response = await configAPI.getTrainingMaterialPdf(materialKey);
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const safeFilename = (filename || `${materialKey}.pdf`)
      .replace(/[^A-Za-z0-9._-]+/g, '_')
      .replace(/^_+|_+$/g, '');
    const link = document.createElement('a');
    link.href = url;
    link.download = safeFilename || `${materialKey}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 5000);
  },
  onError: () => {
    toast.error('Could not download the source PDF.');
  },
});

export default useTrainingMaterials;

